import React from 'react';
import { FaTag } from 'react-icons/fa';
import GenericCrudPage from '../components/GenericCrudPage';

const BASE_URL = process.env.REACT_APP_BASE_URL;

// Validation for category form
const validateCategoryForm = (form) => {
  const errors = {};
  if (!form.exCategoryName.trim()) errors.exCategoryName = "Category Name is required";
  if (form.exCategoryName.length > 100) errors.exCategoryName = "Category Name must be less than 100 characters";
  return errors;
};

// Configuration for Category CRUD operations
const categoryConfig = {
  baseUrl: BASE_URL,
  endpoints: {
    fetch: '/master/getCategory',
    save: '/master/saveCategory',
    update: '/master/updateCategory',
    delete: '/master/deleteCategory'
  },
  validateForm: validateCategoryForm,
  initialFormState: { exCategoryName: "", exIsActive: 1, user: "" },
  entityName: 'Category'
};

// Form fields configuration
const formFields = [
  { name: "exCategoryName", label: "Category Name", icon: FaTag, required: true }
];

// Table columns configuration
const tableColumns = [
  {
    key: 'exCategoryName',
    label: 'Category Name',
    sortable: true,
    render: (category) => <div className="fw-bold">{category.exCategoryName}</div>
  }
];

// CSV export headers
const csvHeaders = [
  { key: 'exCategoryName', label: 'Category Name' },
  { key: 'exIsActive', label: 'Status' }
];

// Get view modal fields
const getViewFields = (category) => {
  if (!category) return [];
  return [
    { label: "Category Name", value: category.exCategoryName, icon: FaTag }
  ];
};

export default function CategoryPage() {
  return (
    <GenericCrudPage
      title="Categories"
      config={categoryConfig}
      formFields={formFields}
      tableColumns={tableColumns}
      emptyIcon={FaTag}
      searchPlaceholder="Search by category name..."
      csvHeaders={csvHeaders}
      csvFilename="categories_export.csv"
      getViewFields={getViewFields}
    />
  );
}